module.exports = __webpack_public_path__ + "static/img/banner-4.1a327d2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/advantage/banner-4.png
// module id = KCgg
// module chunks = 1